import { getMySummaryInitiativesTableDataApi } from '../api';

export const getMySummaryInitiativesTableData = async ({ resourceType, attributeFilter, pageType }) => {
  try {
    const res = await getMySummaryInitiativesTableDataApi({
      resourceType,
      attributeFilter,
      pageType,
    });
    return res?.entity;
  } catch (err) {
    console.error('Error fetching data for initiatives ag grid: ', err);
  }
};
